/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BrandInputs */

const en_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const es_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const de_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const zh_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf`)
};

const ar_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const fr_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const vi_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const sw_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const th_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf`)
};

const bs_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const ja_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const ko_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const pt_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const it_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const sv_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const nl_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const da_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const nb_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const fi_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const pl_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const ru_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const tr_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const hi_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const id_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const ms_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const cs_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const el_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const he_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const af_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

const hu_nav_brand = /** @type {(inputs: Nav_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MARK EGLY GOLF`)
};

/**
* | output |
* | --- |
* | "MARK EGLY GOLF" |
*
* @param {Nav_BrandInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_brand = /** @type {((inputs?: Nav_BrandInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BrandInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_brand(inputs)
	if (locale === "de") return de_nav_brand(inputs)
	if (locale === "zh") return zh_nav_brand(inputs)
	if (locale === "ar") return ar_nav_brand(inputs)
	if (locale === "fr") return fr_nav_brand(inputs)
	if (locale === "vi") return vi_nav_brand(inputs)
	if (locale === "sw") return sw_nav_brand(inputs)
	if (locale === "th") return th_nav_brand(inputs)
	if (locale === "bs") return bs_nav_brand(inputs)
	if (locale === "ja") return ja_nav_brand(inputs)
	if (locale === "ko") return ko_nav_brand(inputs)
	if (locale === "pt") return pt_nav_brand(inputs)
	if (locale === "it") return it_nav_brand(inputs)
	if (locale === "sv") return sv_nav_brand(inputs)
	if (locale === "nl") return nl_nav_brand(inputs)
	if (locale === "da") return da_nav_brand(inputs)
	if (locale === "nb") return nb_nav_brand(inputs)
	if (locale === "fi") return fi_nav_brand(inputs)
	if (locale === "pl") return pl_nav_brand(inputs)
	if (locale === "ru") return ru_nav_brand(inputs)
	if (locale === "tr") return tr_nav_brand(inputs)
	if (locale === "hi") return hi_nav_brand(inputs)
	if (locale === "id") return id_nav_brand(inputs)
	if (locale === "ms") return ms_nav_brand(inputs)
	if (locale === "cs") return cs_nav_brand(inputs)
	if (locale === "el") return el_nav_brand(inputs)
	if (locale === "he") return he_nav_brand(inputs)
	if (locale === "af") return af_nav_brand(inputs)
	if (locale === "hu") return hu_nav_brand(inputs)
	return en_nav_brand(inputs)
});